



// --- 테스트 할때 
const config = {
 backendUrl: 'http://192.168.105.10:5000',
};


// //--- 배포할때 
//  const config = {
//    backendUrl: `${window.location.protocol}//${window.location.hostname}:5000`,
//  };



export default config;
